import TableCard from "../../components/TableCard";
import GavelIcon from "@mui/icons-material/Gavel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PeopleIcon from "@mui/icons-material/People";
import GroupsIcon from "@mui/icons-material/Groups";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useEffect, useState } from "react";
import {
  buscarUsuarios,
  buscarUsuariosPorTexto,
} from "../../services/api-planejamento-tributario.service";
import styles from "./styles.module.css";
import ModalVisualizar from "./ModalVisualizar";
import ModalFilhos from "./ModalFilhos";
import { buscarParametroPorChave } from "../../services/auth.service";
import feriados from "../../utils/feriados.json";
import { formataCnpj, formataCpf } from "../../utils/formatacoes";
import DescriptionIcon from "@mui/icons-material/Description";
import NovoExportador from "../../components/BotaoRelatorio/NovoExportador";
import { FindInPage } from "@mui/icons-material";
import Loading from "../../components/Loading";
import ArticleIcon from "@mui/icons-material/Article";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import ModalContratos from "./ModalContratos";
import AnexoContrato from "../AnexoContrato";
import ModalAnaliseSimples from "./ModalAnaliseSimples";

const Juridico = () => {
  const [data, setData] = useState([]);
  const [openVisualizar, setOpenVisualizar] = useState(false);
  const [dadosUsuarios, setDadosUsuarios] = useState({ id: "", tipo: "" });
  const [openFilhos, setOpenFilhos] = useState(false);
  const [dadosFilho, setDadosFilho] = useState("");
  const [prazo, setPrazo] = useState(0);
  const [modalRelatorio, setModalRelatorio] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalContrato, setModalContrato] = useState(false);
  const [openAnexoContrato, setOpenAnexoContrato] = useState(false);
  const [openAnaliseSimples, setOpenAnaliseSimples] = useState({open: false, id: ""})

  useEffect(() => {
    const buscarParametro = async () => {
      const responsePrazo = await buscarParametroPorChave("prazo-juridico");
      setPrazo(parseInt(responsePrazo.parametro.valor));
    };
    buscarParametro();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get("id");
    const tipo = urlParams.get("tipo");
    id && handleClick(id, tipo, "N");
  }, []);

  useEffect(() => {
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get("id");
    const tipo = urlParams.get("tipo");
    id && handleClick(id, tipo, "N");

    const contact = urlParams.get("contact");
    const type = urlParams.get("type");
    if (contact && type) {
      setDadosUsuarios({ id: contact, tipo: type });
      setModalContrato(true);
    }
  }, [window.location.search]);

  useEffect(() => {
    handleDadosIniciais();
  }, [prazo]);

  const handleDadosIniciais = async () => {
    try {
      const response = await buscarUsuarios();
      setData(handleOrganizaData(response.usuarios));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleModalContrato = (value, id, tipo) => {
    setModalContrato(value);
    if (value) {
      setDadosUsuarios({ id, tipo });
    } else {
      setDadosUsuarios({ id: "", tipo: "" });
    }
  };

  const handleAnexoContrato = async (value, dados) => {
    setDadosUsuarios(dados ?? { id: "", tipo: "" });
    setOpenAnexoContrato(value);
    !value && handleDadosIniciais();
  };

  // useEffect(() => {
  //   if (textoBusca) {
  //     handlePesquisaPorTexto(textoBusca);
  //   } else {
  //     handleDadosIniciais();
  //   }
  // }, [rowsPage, page]);

  const handleCloseVisualizar = () => {
    setOpenVisualizar(false);
  };

  const handleOpenFilhos = (title, idPai, pai) => {
    setDadosFilho({ title, idPai, pai });
    setOpenFilhos(true);
  };

  const handleCloseFilhos = () => {
    handleDadosIniciais();
    setOpenFilhos(false);
  };

  const handleClick = (id, tipo, status) => {
    setOpenVisualizar(true);
    setDadosUsuarios({ id, tipo, status });
  };

  const handlePesquisaPorTexto = async (value) => {
    try {
      setLoading(true);
      if (value === "") {
        const response = await buscarUsuarios();
        setData(handleOrganizaData(response.usuarios));
      } else {
        const response = await buscarUsuariosPorTexto(value);
        setData(handleOrganizaData(response.usuarios));
      }
    } catch (error) {
      console.log(error.response.data.mensagem);
    } finally {
      setLoading(false);
    }
  };

  const handleDiasUteis = (dataInicial) => {
    if (dataInicial) {
      let novaData = new Date(dataInicial);
      let diasAdicionados = 0;
      const anoAtual = novaData.getFullYear();
      const diasUteis = prazo;
      let feriadosStr = feriados.map(
        (feriado) =>
          `${String(feriado.mes).padStart(2, "0")}-${String(
            feriado.dia
          ).padStart(2, "0")}`
      );
      while (diasAdicionados < diasUteis) {
        novaData.setDate(novaData.getDate() + 1);

        if (novaData.getDay() !== 0 && novaData.getDay() !== 6) {
          let dataStr = `${String(novaData.getMonth() + 1).padStart(
            2,
            "0"
          )}-${String(novaData.getDate()).padStart(2, "0")}`;
          if (!feriadosStr.includes(dataStr)) {
            diasAdicionados++;
          } else {
            novaData.setDate(novaData.getDate() + 1);
          }
        }
      }
      let dia = String(novaData.getDate()).padStart(2, "0");
      let mes = String(novaData.getMonth() + 1).padStart(2, "0"); // Janeiro é 0!

      return `${dia}/${mes}/${anoAtual}`;
    } else {
      return "-";
    }
  };

  const handleOrganizaData = (response) => {
    const data = response.map((item) => {
      let btn = "";
      let novoStatus = "";
      switch (item.tipo) {
        case "Associado":
          btn = [
            item.status !== "ANALISANDO"
              ? {
                  icon: <ArticleIcon />,
                  title: "DADOS",
                  onClick: () => handleClick(item.id, item.tipo, "V"),
                }
              : {
                  icon: <AttachMoneyIcon />,
                  title: "NEGOCIAR",
                  onClick: () => handleClick(item.id, item.tipo, "N"),
                },
            {
              icon: <PeopleIcon />,
              title: "PARCEIROS",
              onClick: () => handleOpenFilhos("Parceiros", item.id, "A"),
            },
            {
              icon: <GroupsIcon />,
              title: "CLIENTES",
              onClick: () => handleOpenFilhos("Clientes", item.idinterno, "A"),
            },
          ];
          break;
        case "Parceiro":
          btn = [
            item.status !== "ANALISANDO"
              ? {
                  icon: <ArticleIcon />,
                  title: "DADOS",
                  onClick: () => handleClick(item.id, item.tipo, "V"),
                }
              : {
                  icon: <AttachMoneyIcon />,
                  title: "NEGOCIAR",
                  onClick: () => handleClick(item.id, item.tipo, "N"),
                },
            {
              icon: <GroupsIcon />,
              title: "CLIENTES",
              onClick: () => handleOpenFilhos("Clientes", item.idinterno, "P"),
            },
          ];
          break;
        case "Cliente":
          btn = [
            item.status !== "ANALISANDO"
              ? item.status === "ANALISANDO_CLIENTE" 
              ?{
                icon: <GavelIcon />,
                title: "ANALISAR",
                onClick: () => setOpenAnaliseSimples({open: true, id: item.id}),
              }
              :{
                  icon: <ArticleIcon />,
                  title: "DADOS",
                  onClick: () => handleClick(item.id, item.tipo, "V"),
                }
              : {
                  icon: <AttachMoneyIcon />,
                  title: "NEGOCIAR",
                  onClick: () => handleClick(item.id, item.tipo, "N"),
                },
          ];
          break;

        default:
          break;
      }

      if (item.status === "AGUARD_ASSINATURA") {
        btn.push({
          icon: <HistoryEduIcon />,
          title: "CONTRATO",
          onClick: () => handleModalContrato(true, item.id, item.tipo),
        });
      }
      if (item.status === "AGUARD_CONTRATO") {
        btn.push({
          icon: <HistoryEduIcon />,
          title: "ENVIAR CONTRATO",
          onClick: () =>
            handleAnexoContrato(true, {
              dados: {
                id: item.idInterno,
                idUsuario: item.id,
                email: item.email,
                nome: item.nome
              },
              tipoUsuario: item.tipo,
            }),
        });
      }

      switch (item.status) {
        case "APROVADO":
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.aprovado} /> Aprovado
            </span>
          );
          break;
        case "ANALISANDO":
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.analise} /> Analisar
            </span>
          );
          break;
        case "REPROVADO":
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.reprovado} /> Reprovado
            </span>
          );
          break;
        case "PENDENTE-EDICAO":
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.revisando} /> Revisando
            </span>
          );
          break;
        case "AGUARD_ASSINATURA":
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.aguardando} /> Aguardando Assinatura
            </span>
          );
          break;
        case "AGUARD_CONTRATO":
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.aguardandoContrato} /> Aguardando Contrato
            </span>
          );
          break;
        case "ANALISANDO_CLIENTE":
          novoStatus = (
            <span className={styles.status_container}>
              <span className={styles.analise} /> Análise Simples
            </span>
          );
          break;

        default:
          break;
      }
      let dtCadastro = new Date(item.dt_cadastro).toLocaleDateString();
      return {
        tipo: item.tipo ?? "-",
        nome: item.nome ?? "-",
        cpf: item.cpf && item.cpf !== "undefined" ? formataCpf(item.cpf) : "-",
        cnpj:
          item.cnpj && item.cnpj !== "undefined" ? formataCnpj(item.cnpj) : "-",
        dtCadastro,
        dtPrazo:
          item.status === "ANALISANDO"
            ? handleDiasUteis(item.dt_cadastro)
            : "-",
        status: item.status ? novoStatus : "-",
        botoes: btn,
      };
    });

    return data;
  };

  const optionsFilter = [
    { value: "tipo: Cliente" },
    { value: "tipo: Parceiro" },
    { value: "tipo: Associado" },
    { value: "status: Aprovado" },
    { value: "status: Reprovado" },
    { value: "status: Analisar" },
    { value: "status: Revisando" },
  ];

  const columns = [
    "Tipo",
    "Nome",
    "CPF",
    "CNPJ",
    "Data Cadastro",
    "Data Prazo",
    "Status",
  ];

  const handleRelatorioModal = () => {
    setModalRelatorio(!modalRelatorio);
  };

  const handleClose = (status) => {
    setModalRelatorio(false);
  };

  const botaoRelatorio = [
    {
      icon: <DescriptionIcon />,
      label: "RELATÓRIO",
      onClick: handleRelatorioModal,
    },
  ];

  return (
    <div>
      <TableCard
        iconHeader={<GroupsIcon fontSize="1rem" />}
        titleHeader="Proponentes"
        optionsFilter={optionsFilter}
        data={data}
        setData={setData}
        columns={columns}
        loading={loading}
        textHeaderCard="nome"
        handleDebounce={handlePesquisaPorTexto}
        codigoRelatorio="CADASTROS_PLAN_TRIB"
        hoverBtnHeader={botaoRelatorio}
      />

      <NovoExportador
        codRelatorio="CADASTROS_PLAN_TRIB"
        handleModal={modalRelatorio}
        close={handleClose}
      />

      <ModalVisualizar
        open={openVisualizar}
        onClose={handleCloseVisualizar}
        dadosUsuarios={dadosUsuarios}
        atualizarDados={handleDadosIniciais}
      />

      <ModalFilhos
        open={openFilhos}
        onClose={handleCloseFilhos}
        dados={dadosFilho}
        atualizaPai={handleDadosIniciais}
      />

      <ModalContratos
        handleOpen={modalContrato}
        handleCLose={handleModalContrato}
        dadosUsuarios={dadosUsuarios}
      />

      <AnexoContrato
        open={openAnexoContrato}
        setOpen={setOpenAnexoContrato}
        dadosUsuario={dadosUsuarios}
        handleCloseAll={() => handleAnexoContrato(false)}
      />

      <ModalAnaliseSimples
      open={openAnaliseSimples.open}
      onClose={() => setOpenAnaliseSimples({open: false, id: ""})}
      id={openAnaliseSimples.id}
      />
    </div>
  );
};

export default Juridico;
